//require('../../node_modules/js-cookie/src/js.cookie.js');
require('./bootstrap');
require('./components/navigation');
require('./components/disclaimer');
//require('./components/ga_tracking');
require('./components/kc_modules');
require('./components/utilities');
//require('./components/carousels');